import { configureStore } from "@reduxjs/toolkit";
import portfolioReducer from "../redux/portfolioSlice";

export const store = configureStore({
  reducer: {
    portfolio: portfolioReducer,
  },
});